import { render, staticRenderFns } from "./vip-tab-aqy.vue?vue&type=template&id=22f9b4a8&scoped=true&"
import script from "./vip-tab-aqy.vue?vue&type=script&lang=js&"
export * from "./vip-tab-aqy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f9b4a8",
  null
  
)

export default component.exports